export const mainCategoriesConstants = {
  FETCH_MAIN_CATEGORIES_SUCCESS: 'FETCH_MAIN_CATEGORIES_SUCCESS',
  FETCH_MAIN_CATEGORIES_LOADING: 'FETCH_MAIN_CATEGORIES_LOADING',
  FETCH_MAIN_CATEGORIES_ERROR: 'FETCH_MAIN_CATEGORIES_ERROR',

  SET_LEVEL_0_FOR_DOCUMENT: 'SET_LEVEL_0_FOR_DOCUMENT',

  FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_SUCCESS: 'FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_SUCCESS',
  FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_LOADING: 'FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_LOADING',
  FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_ERROR: 'FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_ERROR',
  FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_RESET: 'FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_RESET',

  FETCH_MAIN_CATEGORIES_LEVEL1_BY_ID_SUCCESS: 'FETCH_MAIN_CATEGORIES_LEVEL1_BY_ID_SUCCESS',
  FETCH_MAIN_CATEGORIES_LEVEL2_BY_ID_SUCCESS: 'FETCH_MAIN_CATEGORIES_LEVEL2_BY_ID_SUCCESS',
  FETCH_MAIN_CATEGORIES_LEVEL3_BY_ID_SUCCESS: 'FETCH_MAIN_CATEGORIES_LEVEL3_BY_ID_SUCCESS',

  FETCH_MAIN_CATEGORIES_BY_ID_LOADING: 'FETCH_MAIN_CATEGORIES_BY_ID_LOADING',
  FETCH_MAIN_CATEGORIES_BY_ID_ERROR: 'FETCH_MAIN_CATEGORIES_BY_ID_ERROR',
} as const
